import React, { useEffect } from "react";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./customCss/Dashboard.css"
import "./customCss/Account.css"
import "./customCss/Clients.css"
import "./customCss/Common.css"
import "./customCss/listTypes.css"
import "./customCss/Login.css"
import "./customCss/ManageOfficers.css"
import "./customCss/Vacation.css"
import Routes from "./Routes";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);
  return (
    <div className="App">
      <Routes />
      <ToastContainer />
    </div>
  );
}

export default App;
